var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24097 40H31.53V31.4451H16.1157V31.2139L19.8152 28.131C28.8132 20.6358 31.1061 16.7437 31.1061 12.1773C31.1061 4.81696 25.0753 0 15.6148 0C6.42402 0 0.450994 5.10597 0.470261 13.4104H10.6437C10.6244 10.0963 12.6475 8.24663 15.6148 8.24663C18.5627 8.24663 20.6629 10.0771 20.6629 13.1021C20.6629 15.896 18.871 17.7071 15.9616 20.1156L1.24097 32.2929V40Z",
    fill: "url(#paint0_linear_77_11220)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_11220",
    x1: 0.47021,
    y1: 39.9999,
    x2: 33.8269,
    y2: 37.9827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.b8f777aff99cf3f51482a3c0dc4d1ebe.svg";
export { ForwardRef as ReactComponent };